<template v-if="numberOfAddOns > 0">
  <tr>
    <td> {{ selectedPackage.display_name }}</td>
    <td>{{ item.cart_text }}</td>
    <td>
      {{ (selectedPackage) }}
    </td>
    <td>
      <PackageFields
        :packages="item.dropdown_items"
        :currency="currency"
        :rate="rate"
        @package-emit="updateSelectedPackage"
        @qty-emit="updatePackageQty"
      />
    </td>
    <td>
      <AddToCart
        :qtyhotel="0"
        :qtypackage="packageQty"
        :idhotel="null"
        :idpackage="selectedPackage.id"
        :idstay="null"
        :form-btn-text="'Add To Basket'"
        @order-item-added="refreshAddOns"
      />
    </td>
  </tr>
</template>

<script>
import AddToCart from '../../add_to_cart_forms/bottom_form/add-to-cart'
import PackageFields from './package_input_fields'
import { CurrencyApi } from '../../../default/currency_convert'

export default {
  components: {
    AddToCart,
    PackageFields
  },

  props: ['item', 'currency', 'rate'],

  data() {
    return {
      selectedPackage: null,
      packageQty: 1
    }
  },

  watch: {
    item() {
      this.updateSelectedPackage(this.item.dropdown_items[0])
    }
  },

  created() {
    this.updateSelectedPackage(this.item.dropdown_items[0])
  },

  methods: {
    refreshAddOns(item) {
      this.$emit('refresh-add-ons', item)
    },

    updateSelectedPackage(pack) {
      if (pack != null) { this.selectedPackage = pack }
    },

    updatePackageQty(qty) {
      if (qty) { this.packageQty = qty }
    },

    formatPrice(pack){
      return CurrencyApi.formatAmount(pack.price * this.rate, this.currency)
    }
  }
}
</script>
